// extracted by mini-css-extract-plugin
module.exports = {"ServiceInfo":"NumbersCard_ServiceInfo__jhUEA","Tit":"NumbersCard_Tit__21ZzH","Desc":"NumbersCard_Desc__3Hiw5"};